import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { Info as InfoCircle } from "@material-ui/icons";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";

import { displayApproveRequestHHRRRequest } from "../../display-approve-hhrr-request";
import { displayRejectHHRRRequest } from "../../display-reject-hhrr-request";
import { displayApproveFinancialRequest } from "../../display-approve-financial-request";
import { displayRejectFinancialRequest } from "../../display-reject-financial-request";
import { translate as t } from "../../../../infrastructure/translate/localization";
import { MonetaryAmount } from "../../../../app/domain/monetary-amount";

import Table from "../../../../app/components/Table";
import TableDataSpinner from "../../../../app/components/modals/employee/DeleteEmployeesModal/components/TableDataSpinner";
import EmptyDataForTableMessage from "../../../../app/components/modals/employee/DeleteEmployeesModal/components/EmptyDataForTableMessage";
import CobeeButton from "../../../../app/components/CobeeButton";
import CobeeTooltip from "../../../../app/components/CobeeTooltip";
import useStyles from "./styles";

const COLUMNS = [
  {
    id: "courseName",
    label: t("request-section.course-name"),
  },
  {
    id: "centreName",
    label: t("request-section.center"),
  },
  {
    id: "employeeName",
    label: t("common-messages.employee"),
  },
  {
    id: "amount",
    label: t("common-messages.amount"),
  },
  {
    id: "actions",
    align: "center",
    label: t("common-messages.actions"),
  },
];

function RequestEducationTable({ requests, isLoading }) {
  const { row, minContent, iconInfo } = useStyles();

  async function approveHHRRRequest({ requestId, amount, employeeId }) {
    await displayApproveRequestHHRRRequest(requestId, amount, employeeId);
  }

  async function rejectHHRRRequest({ requestId }) {
    await displayRejectHHRRRequest(requestId);
  }

  async function approveFinancialRequest({ requestId, amount, fromFunds }) {
    await displayApproveFinancialRequest({ requestId, amount, fromFunds });
  }

  async function rejectFinancialRequest({ requestId }) {
    await displayRejectFinancialRequest(requestId);
  }

  if (isLoading) {
    return <TableDataSpinner />;
  }
  if (!isLoading && requests.length === 0) {
    return <EmptyDataForTableMessage />;
  }

  return (
    <Grid item xs={12} container>
      <Table
        columns={COLUMNS}
        data={requests.map(
          ({
            requestId,
            courseName,
            centreName,
            employeeName,
            employeeId,
            amount,
            approvers,
            fromFunds,
          }) => {
            return {
              courseName,
              centreName,
              employeeName,
              amount: (
                <Grid item className={minContent}>
                  {MonetaryAmount.fromUnitary(amount).prettifyMoney({})}
                </Grid>
              ),
              actions:
                approvers.length === 0 ? (
                  <Grid
                    container
                    spacing={1}
                    direction="column"
                    justify="space-around"
                    alignItems="center"
                    className={row}
                  >
                    <Grid container direction="row" justify="center">
                      <p>
                        <span>1/2:</span> {t("request-section.approve-hhrr")}
                      </p>
                      <CobeeTooltip
                        title={t(
                          "request-section.request-hhrr-tooltip-message"
                        )}
                      >
                        <InfoCircle className={iconInfo} size={14} />
                      </CobeeTooltip>
                    </Grid>

                    <Grid
                      container
                      spacing={1}
                      direction="row"
                      justify="center"
                    >
                      <Grid item>
                        <CobeeButton
                          onClick={() =>
                            approveHHRRRequest({
                              requestId,
                              amount,
                              employeeId,
                            })
                          }
                        >
                          {t("actions.approve")}
                        </CobeeButton>
                      </Grid>
                      <Grid item>
                        <CobeeButton
                          onClick={() => rejectHHRRRequest({ requestId })}
                        >
                          {t("actions.reject")}
                        </CobeeButton>
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid
                    container
                    spacing={1}
                    direction="column"
                    justify="space-around"
                    alignItems="center"
                    className={row}
                  >
                    <Grid container direction="row" justify="center">
                      <p>
                        <span>2/2:</span>{" "}
                        {t("request-section.approve-financial")}
                      </p>
                      <CobeeTooltip
                        title={t(
                          "request-section.request-finnacial-tooltip-message"
                        )}
                      >
                        <InfoCircle className={iconInfo} size={14} />
                      </CobeeTooltip>
                    </Grid>

                    <Grid
                      container
                      spacing={1}
                      direction="row"
                      justify="center"
                    >
                      <Grid item>
                        <CobeeButton
                          onClick={() =>
                            approveFinancialRequest({
                              requestId,
                              amount,
                              fromFunds,
                            })
                          }
                        >
                          {t("request-section.choose-quotas")}
                        </CobeeButton>
                      </Grid>
                      <Grid item>
                        <CobeeButton
                          styleType="iconOnlySecondary"
                          onClick={() => rejectFinancialRequest({ requestId })}
                        >
                          <CloseOutlinedIcon />
                        </CobeeButton>
                      </Grid>
                    </Grid>
                  </Grid>
                ),
            };
          }
        )}
      />
    </Grid>
  );
}

RequestEducationTable.defaultProps = {
  isLoading: false,
  requests: [],
};

RequestEducationTable.propTypes = {
  isLoading: PropTypes.bool,
  requests: PropTypes.array,
};

export default RequestEducationTable;
